// extracted by mini-css-extract-plugin
module.exports = {"container":"ext.src.popup_container__2o-Zg","title":"ext.src.popup_title__TIhqu"};